import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import LoginPage from './components/login';
import AdminPage from './components/AdminPage';
import StudentPage from './components/StudentPage';
import ManageUserPage from './components/ManageUsersPage';
import AShare from './components/AShare';
import ControlPage from './components/control';
import FeedbackControlPage from './components/FeedbackControl';
import PrivateRoute from './PrivateRoute'; // Import the updated PrivateRoute
import Header from './components/Header';
import Footer from './components/Footer';
import NotFoundPage from './components/NotFoundPage'; // Import the NotFoundPage component
import { getAuth } from 'firebase/auth';
import HomePage from './components/HomePage';

const App = () => {
  const auth = getAuth();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      setUser(auth.currentUser);
    }
  }, [auth]);

  return (
    <Router>
      <Main user={user} auth={auth} />
    </Router>
  );
};

const Main = ({ user, auth }) => {
  const location = useLocation(); // Now it's inside the Router context
  const showHeader = location.pathname !== '/admin'; // Don't show header for /admin page

  return (
    <>
      {showHeader && <Header />} {/* Conditionally render Header */}

      <main
        style={{
          paddingTop: '4rem',
          paddingBottom: '4rem',
          minHeight: 'calc(100vh - 8rem)',
        }}
      >
        {user && (
          <a
            href="/student"
            className="position-fixed bottom-0 start-0 mb-2 ms-2 d-flex align-items-center p-2 text-decoration-none"
            style={{
              zIndex: 1050,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '30px',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
            }}
          >
            <img
              src={user.photoURL}
              alt={user.email}
              className="rounded-circle me-2"
              style={{
                height: '50px',
                width: '50px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                border: '2px solid #046655',
              }}
            />
            <span style={{ color: '#046655', fontWeight: '600', fontSize: '1rem' }}>
              {user.displayName || user.email}
            </span>
          </a>
        )}

        <Routes>
        <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Admin routes protected by PrivateRoute */}
          <Route path="/admin" element={<PrivateRoute adminOnly={true}><AdminPage /></PrivateRoute>} />
          <Route path="/admin/users" element={<PrivateRoute adminOnly={true}><ManageUserPage /></PrivateRoute>} />
          <Route path="/admin/share" element={<PrivateRoute adminOnly={true}><AShare /></PrivateRoute>} />
          <Route path="/admin/control" element={<PrivateRoute adminOnly={true}><ControlPage /></PrivateRoute>} />
          <Route path="/admin/FeedbackControl" element={<PrivateRoute adminOnly={true}><FeedbackControlPage /></PrivateRoute>} />

          {/* Student routes */}
          <Route path="/student" element={<PrivateRoute><StudentPage /></PrivateRoute>} />

          {/* Not Found Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
};

export default App;
